export const SINGLE_THUMB = {
  height: 34,
  width: 60,
};

const MULTIPLE_THUMBS = {
  primaryHeight: SINGLE_THUMB.height,
  primaryWidth: 38,
  secondaryHeight: 15,
  secondaryWidth: 18,
};

export const getThumbSize = (thumbCount: number, index = 0) => {
  switch (thumbCount) {
    case 1:
      return {
        height: SINGLE_THUMB.height,
        width: SINGLE_THUMB.width,
      };

    case 2:
      return {
        height: MULTIPLE_THUMBS.primaryHeight,
        width:
          index === 0
            ? MULTIPLE_THUMBS.primaryWidth
            : MULTIPLE_THUMBS.secondaryWidth,
      };

    case 3:
      return {
        height:
          index === 0
            ? MULTIPLE_THUMBS.primaryHeight
            : MULTIPLE_THUMBS.secondaryHeight,
        width:
          index === 0
            ? MULTIPLE_THUMBS.primaryWidth
            : MULTIPLE_THUMBS.secondaryWidth,
      };

    default:
      return {
        height: SINGLE_THUMB.height,
        width: SINGLE_THUMB.width,
      };
  }
};
